import React from "react";
import "./images.css";

import Image from "../../../../../components/image/image";

class Images extends React.Component {
  render() {
    return (
      <div className="contentBlock images">
        {this.props.images.map((image, index) => (
          <div className="image" key={index}>
            <Image
              src={image.fields.file.url}
              alt=""
              handleImageCreate={this.props.handleImageCreate}
              handleImageLoaded={this.props.handleImageLoaded}
            />
          </div>
        ))}
      </div>
    );
  }
}
export default Images;
